import axios from 'axios';
import { constant } from '@app/utils/constant';
import Cookies from 'js-cookie';

export const getPortals = async (filter: any) => {
  const BearerToken = Cookies.get(constant.Cookie_Name);
  let queryString = 'per_page=5000';
  let restype = 'json';
  try {
    const response = await axios.get(constant.API_BASEPATH + '/portals?' + queryString, { headers: { "Authorization": `Bearer ${BearerToken}` }, responseType: restype });
    return response;
  } catch (err) {
    console.log(err);
  }
};

export const getUserPortals = async (filter: any) => {
  const BearerToken = Cookies.get(constant.Cookie_Name);
  let queryString = 'per_page=5000';
  let restype = 'json';
  try {
    const response = await axios.get(constant.API_BASEPATH + '/user-portals?' + queryString, { headers: { "Authorization": `Bearer ${BearerToken}` }, responseType: restype });
    return response;
  } catch (err) {
    console.log(err);
  }
};


export const getPortalById = async (id: number) => {
  const BearerToken = Cookies.get(constant.Cookie_Name);
  try {
    const response = await axios.get(constant.API_BASEPATH + '/portals/' + id, { headers: { "Authorization": `Bearer ${BearerToken}` } });
    return response;
  } catch (err) {
    console.log(err);
    return { 'data': err.response.data };
  }
};

export const updatePortal = async (id: number, data: any) => {
  const BearerToken = Cookies.get(constant.Cookie_Name);
  try {
    const response = await axios.put(constant.API_BASEPATH + '/portals/' + id, data, { headers: { "Authorization": `Bearer ${BearerToken}` } });
    return response;
  } catch (err) {
    console.log(err);
    return { 'data': err.response.data };
  }
};






